import React, {useEffect, useState} from 'react';
import Layout from '../components/Layout';
import {api} from '../../api';


export default function Settings() {
  const [serviceTypes, setServiceTypes] = useState([]);
  const [newName, setNewName] = useState('');

  const load = () => api(`/service-types`).then(r => r.json()).then(setServiceTypes).catch(() => {});

  useEffect(() => { load(); }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    await api(`/service-types`, { method: 'POST', body: JSON.stringify({ name: newName.trim() }) });
    setNewName('');
    load();
  };

  const handleDelete = async (id) => {
    await api(`/service-types/${id}`, { method: 'DELETE' });
    load();
  };

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow max-w-2xl">
        <div className="p-4 md:p-6 border-b">
          <h1 className="text-2xl font-bold text-gray-900">Settings</h1>
        </div>
        <div className="p-4 md:p-6">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">Service Types</h2>
          <form onSubmit={handleAdd} className="flex gap-3 mb-6">
            <input
              type="text"
              placeholder="New service type..."
              value={newName}
              onChange={(e) => setNewName(e.target.value)}
              className="flex-1 px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-600"
            />
            <button type="submit" className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700">Add</button>
          </form>
          <ul className="divide-y divide-gray-200">
            {serviceTypes.map((st) => (
              <li key={st.id} className="flex items-center justify-between py-3">
                <span className="text-gray-900">{st.name}</span>
                <button onClick={() => handleDelete(st.id)} className="text-purple-600 hover:text-purple-800 text-sm font-medium">Remove</button>
              </li>
            ))}
          </ul>
          {serviceTypes.length === 0 && (
            <p className="text-gray-500 text-center py-4">No service types defined yet.</p>
          )}
        </div>
      </div>
    </Layout>
  );
}
